export enum BotIdentificator {
  SupportBot = 1,
  NotificationBot = 2,
  VacantBot = 3,
}

export class Bot {
  id: BotIdentificator;
}
